// Shared so the "days until APN cert expiry" math lives in exactly one
// place, used by both the APN setup wizard and the dashboard banner.
// Replaces the Math.abs()-based diff in the wizard, which couldn't tell
// an already-expired cert from one expiring in exactly 30 days.

export function getCertExpiryStatus(certificateData) {
    if (!certificateData || !certificateData.validity || !certificateData.validity.notAfter) {
        return null;
    }
    const notAfter = new Date(certificateData.validity.notAfter);
    const today = new Date();
    const diffDays = Math.ceil((notAfter - today) / (1000 * 60 * 60 * 24));
    return {
        notAfter,
        diffDays,
        isExpired: diffDays < 0,
        isExpiringSoon: diffDays >= 0 && diffDays <= 30,
    };
}